(function () {
  var cards = document.querySelectorAll('[data-ramsak-planner]');
  Array.prototype.forEach.call(cards, function (card) {
    var form = card.closest('form');
    var guests = 2;
    var price = Number(card.getAttribute('data-price')) || 15;
    var date = card.querySelector('[data-date]');
    var time = card.querySelector('[data-time]');
    var name = card.querySelector('input[name="contact[name]"]');
    var email = card.querySelector('input[name="contact[email]"]');
    var message = card.querySelector('textarea[name="contact[body]"]');
    var minus = card.querySelector('[data-minus]');
    var plus = card.querySelector('[data-plus]');
    var key = 'ramsak-tasting-draft';
    var success = new URLSearchParams(window.location.search).get('tasting_sent') === '1' ||
      new URLSearchParams(window.location.search).get('contact_posted') === 'true' ||
      !card.querySelector('[data-success-message]').hidden;
    var today = new Date();
    today.setDate(today.getDate() + 3);
    date.min = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
    function update() {
      card.querySelector('[data-guests]').textContent = guests;
      card.querySelector('[data-total]').textContent = '€' + (guests * price);
      card.querySelector('[data-guests-input]').value = guests;
      card.querySelector('[data-total-input]').value = '€' + (guests * price);
      card.querySelector('[data-reply-email]').value = email.value;
      minus.disabled = guests <= 1;
      plus.disabled = guests >= 30;
    }
    if (success) {
      card.querySelector('[data-success-message]').hidden = false;
      card.querySelector('[data-form-fields]').hidden = true;
      try { sessionStorage.removeItem(key); } catch (e) {}
      card.scrollIntoView({block: 'center'});
      if (window.location.search.indexOf('tasting_sent=1') !== -1) {
        history.replaceState(null, '', window.location.pathname + window.location.hash);
      }
      return;
    }
    try {
      var saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved) {
        guests = Math.max(1, Math.min(30, Number(saved.guests) || 2));
        name.value = name.value || saved.name || '';
        email.value = email.value || saved.email || '';
        date.value = saved.date || '';
        time.value = saved.time || '16:00';
        message.value = message.value || saved.message || '';
      }
    } catch (e) {}
    minus.addEventListener('click', function () { guests = Math.max(1, guests - 1); update(); });
    plus.addEventListener('click', function () { guests = Math.min(30, guests + 1); update(); });
    email.addEventListener('input', update);
    form.addEventListener('submit', function () {
      update();
      try { sessionStorage.setItem(key, JSON.stringify({guests: guests, name: name.value, email: email.value, date: date.value, time: time.value, message: message.value})); } catch (e) {}
    });
    update();
    if (card.querySelector('[data-form-fields]').hidden) card.querySelector('[data-form-fields]').hidden = false;
    if (window.location.hash === '#ramsak-visit' && card.querySelector('.ramsak-visit__error')) card.scrollIntoView({block: 'center'});
  });
}());
